import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // true on mount to check stored session

  // On mount — try to restore session from localStorage
  useEffect(() => {
    const restore = async () => {
      const storedUser = api.getStoredUser();
      const token = api.getAccessToken();

      if (storedUser && token) {
        // Validate token by calling /auth/me
        try {
          const freshUser = await api.getMe();
          setUser(freshUser);
        } catch {
          // Token expired / invalid — clear
          api.clearTokens();
          setUser(null);
        }
      }
      setLoading(false);
    };
    restore();
  }, []);

  const login = useCallback(async (email, password) => {
    setLoading(true);
    try {
      const result = await api.login(email, password);
      setUser(result.user);
      return { success: true };
    } catch (err) {
      const message = err.data?.error?.message || err.message || 'Login failed';
      return { success: false, error: message };
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(async () => {
    await api.logout();
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
